module.exports = __webpack_public_path__ + "static/media/country_kg.4411aab3.webp";